import 'chartjs-adapter-date-fns';
import Chart from 'chart.js/auto';

let originalLowestPriceElement, originalLowestPriceText;

/**
 * Stores product lowest price in variable.
 *
 * @return {void}
 */
function addProductPriceText() {
	originalLowestPriceElement.innerHTML = originalLowestPriceText;
}

/**
 * On page load, check if product page.
 * Store original product text for when no variation selected.
 * Get selected variations.
 *
 * @return {void}
 */
document.addEventListener( 'DOMContentLoaded', () => {
	// Check it is a product page.
	if ( document.getElementsByClassName( 'single-product' ).length > 0 ) {
		originalLowestPriceElement = document.querySelector(
			'.lowest-price-in-last-30-days .lowest-price-in-last-30-days__details'
		);

		if ( ! originalLowestPriceElement ) {
			return;
		}

		/**
		 * Save original product text for when nothing selected.
		 */
		originalLowestPriceText = originalLowestPriceElement.innerHTML;

		const selectedVariationsOnLoad = getSelectedVariations();

		/**
		 * Check there are selected variable products.
		 */
		if ( selectedVariationsOnLoad.length > 0 ) {
			getAttributes( selectedVariationsOnLoad );
		}

		/**
		 * On variation selection, get attributes selected.
		 */
		jQuery( document.body ).on( 'found_variation', variation => {
			if ( ! variation ) {
				return;
			}

			const selectedVariations = getSelectedVariations();

			if ( selectedVariations.length > 0 ) {
				getAttributes( selectedVariations );
			} else {
				// If nothing selected, show original lowest price.
				addProductPriceText();
			}
		} );
	}
} );

/**
 * Get attributes and concatenate names.
 * Variation name here needs to match variation name output in display_lowest_price class
 * Example - Red: Large.
 *
 * @param {Array} selectedVariations
 * @return {void}
 */
function getAttributes( selectedVariations ) {
	const variationNames = [];
	selectedVariations.forEach( variation => {
		variationNames.push( capitaliseFirstLetter( variation?.value || '' ) );
	} );

	const joinedName = variationNames.join( ': ' );

	Array.from( selectedVariations ).forEach( () => {
		updateLowestPrice( joinedName );
	} );
}

/**
 * Capitalise first letter of string.
 *
 * @param {string} s
 * @return {void}
 */
const capitaliseFirstLetter = s => s && s[ 0 ].toUpperCase() + s.slice( 1 );

/**
 * Get the current selected variations.
 *
 * @return {Array} the currently selected variations.
 */
function getSelectedVariations() {
	const variationsForm = document.querySelector( '.variations_form' );

	if ( ! variationsForm?.length > 0 ) {
		return [];
	}

	const selects = variationsForm.querySelectorAll( '.variations select' );

	if ( ! selects.length > 0 ) {
		return [];
	}

	// Initialize an array to hold select elements with a value
	const selectsWithValue = [];

	// Iterate over the NodeList
	selects.forEach( function( select ) {
		// Check if the select has a value
		if ( select.value ) {
			// Add the select element to the array
			selectsWithValue.push( select );
		}
	} );

	return selectsWithValue;
}

/**
 * Get lowest price for variations from log and display.
 *
 * @param {string} variationValue
 * @return {void}
 */
function updateLowestPrice( variationValue ) {
	// Get lowest price
	const variationsLowestPrices = QalaProductPriceHistoryVariationsLowestPrices;

	if (
		typeof variationsLowestPrices[ variationValue ] === 'undefined' ||
		null === variationsLowestPrices[ variationValue ]
	) {
		return;
	}

	// Example output - Our lowest price in the past 30 days before the current price: £35.00. (Hoodie: Large)
	const lowestPriceText = document.querySelector(
		'.lowest-price-in-last-30-days .lowest-price-in-last-30-days__details'
	);
	lowestPriceText.innerHTML =
		variationsLowestPrices[ variationValue ] +
		'. (' + variationValue + ')';
}

/**
 * Create price history chart using chart logs.
 *
 * @return {void}
 */
function buildChart() {
	// Exit early if we're missing the necessary data.
	if (
		typeof ( qalaPriceHistory ) === 'undefined' ||
		qalaPriceHistory.hasOwnProperty( 'chartConfig' ) === false ||
		document.querySelectorAll( '.single-product' ).length === 0 ||
		document.querySelectorAll( '.product-block-price-history' ).length === 0
	) {
		return;
	}

	const chartEl = document.querySelector( '#qala-product-price-history-canvas' );
	new Chart( chartEl, qalaPriceHistory.chartConfig );
}

buildChart();
